/**
 * @typedef Skills
 * @returns {{
 *  list(): Promise,
 *  tree(): Promise,
 *  get(slug: String): Promise,
 *  update(payload: Object): Promise,
 *  add(payload: Object): Promise,
 *  delete(id: [String, Number]): Promise
 * }}
 */
export const Skills = axios => ({
  /**
   * Get skills list
   *
   * @returns Promise
   */
  list() {
    return axios.get('/v1/skills/')
  },

  /**
   * Get skills tree
   *
   * @returns Promise
   */
  tree() {
    return axios.get('/v1/skills/tree')
  },

  /**
   * Get skill
   *
   * @param {String} slug
   *
   * @returns Promise
   */
  get(slug) {
    return axios.get(`/v1/skills/${slug}`)
  },

  /**
   * Update skill
   *
   * @param {Object} payload
   *
   * @returns Promise
   */
  update(payload) {
    return axios.put('/v1/skills/', payload)
  },

  /**
   * Create skill
   *
   * @param {Object} payload
   *
   * @returns Promise
   */
  add(payload) {
    return axios.post('/v1/skills', payload)
  },

  /**
   * Delete skill
   *
   * @param {String|Number} id
   *
   * @returns Promise
   */
  delete(id) {
    return axios.delete(`/v1/skills/${id}`)
  }
})
